import React from 'react';
import { withRouter } from 'utils/withRouter';
import styled from 'styled-components';
import Sticky from 'common/sticky/sticky';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Button, Icon } from 'ui';
import { Row, Col, Input } from 'antd';
import { usersDefaultSortColumn } from 'utils/app-configs';
import debounce from 'lodash.debounce';
// eslint-disable-next-line
import ServiceCenterToggle from 'header/service-center-toggle/containers/service-center-toggle-container';
import SortDropdown from '../../../worklist/components/toolbar/sort-dropdown';

const { Search } = Input;

const StyledRow = styled(Row)`
  margin: 0 20px;
  height: 55px;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const FlexCol = styled(Col)`
  display: flex;
  align-items: center;
`;

const BorderedCol = styled(FlexCol)`
  border-left: #d9e0e6 1px solid;
`;

const StyledSearch = styled(Search)`
  margin: 0 10px 0 20px;
  .ant-input-group-addon {
    display: none;
  }
  .ant-input-affix-wrapper {
    height: 30px;
    input {
      height: auto;
      font-size: 16px;
    }
  }
`;

const StyledSpan = styled.span`
  font-size: 13px;
  line-height: 1.5;
`;

const StyledButton = styled(Button)`
  text-transform: uppercase;
  margin: 0 20px;
  color: white;
  background-color: ${p => p.theme.colors.theme} !important;
  &:hover {
    opacity: 0.7;
    color: white !important;
  }
  &:focus {
    color: white;
  }
`;

const StyledIcon = styled(Icon)`
  color: white;
  margin-right: 10px;
`;

const UserManagementToolbar = ({
  menuVisible,
  data,
  columnDef,
  updateSort,
  activeSort,
  addUsers,
  isSearching = false,
  updateSearchString,
  intl,
}) => {
  const extraStyles = `
    background-color: rgb(245, 248, 250) !important;
    height: 55px;
    margin: 0 -20px;
  `;

  const serviceCenterToggleStyle = `
    margin: 0 20px;
    flex-grow: 3;
  `;

  const handleSearch = debounce((value) => {
    updateSearchString(value);
  }, 450);

  const handleChange = (e) => {
    handleSearch(e.target.value);
  };

  return (
    <Sticky menuVisible={menuVisible} extraStyles={extraStyles}>
      <StyledRow type='flex'>
        <FlexCol span={7}>
          <StyledSpan>
            {intl.formatMessage({ id: 'userManagement.CUSTOMER_CENTER' })}{':'}
          </StyledSpan>
          <ServiceCenterToggle
            needsRedirect={false}
            extraStyles={serviceCenterToggleStyle}
            onlyAdmin={true}
          />
        </FlexCol>
        <BorderedCol span={7}>
          <StyledSearch
            placeholder={intl.formatMessage({ id: 'userManagement.SEARCH_USER' })}
            prefix={<Icon type='search' />}
            loading={isSearching}
            onChange={handleChange}
            allowClear={true}
          />
        </BorderedCol>
        <Col span={5}>
          <SortDropdown
            columnDef={columnDef}
            data={data}
            isLoading={false}
            defaultSortId={usersDefaultSortColumn}
            activeSort={activeSort}
            updateSort={updateSort}
          />
        </Col>
        <BorderedCol span={5}>
          <StyledButton onClick={addUsers}>
            <StyledIcon type='user-plus' />
            {intl.formatMessage({ id: 'userManagement.ADD_USER' })}
          </StyledButton>
        </BorderedCol>
      </StyledRow>
    </Sticky>
  );
};
UserManagementToolbar.propTypes = {
  menuVisible: PropTypes.bool,
  data: PropTypes.array,
  columnDef: PropTypes.array,
  updateSort: PropTypes.func,
  activeSort: PropTypes.string,
  addUsers: PropTypes.func,
  isSearching: PropTypes.bool,
  updateSearchString: PropTypes.func,
  intl: PropTypes.object,
};

export default withRouter(injectIntl(UserManagementToolbar));
